import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { UsersComponent } from '../users/users.component';
import { ApplyStatusComponent } from '../apply-status/apply-status.component';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';
import { UserService } from '../../services/user.service';
import { ApplyStatusService } from '../../services/apply-status.service';
import { EnterpriseService } from '../../services/enterprise.service';
import { Enterprise } from '../../models/enterprise';
import { User } from '../../models/user';
import { ApplyStatus } from '../../models/apply-status';
import { TypeEvent } from '../../models/type-event';
import { TypeEventService } from '../../services/type-event.service';
import { TypeEventComponent } from '../type-event/type-event.component';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent implements OnInit {
  selectedOption: string;
  publicating: boolean = false;
  enterprise: Enterprise;
  users:any;
  applyStatuses:any;
  errorMessage:string;
  loading_user: boolean;
  loading_enterprise: boolean;
  loading_applyStatus: boolean;

  typeEventses: TypeEvent;
  loading_typeEvent: boolean;
  page_type_event: number;
  max_type_event: number;
  total_type_event: number;
  total_users: 0;
  max_users: 0;

  page_apply_status: number;
  total_apply_status: number;
  max_apply_status: number;
  premium: string;

  constructor(public dialog: MdDialog,
    public userService: UserService,
    public applyStatusService: ApplyStatusService,
    public enterpriseService: EnterpriseService,
    public typeEventService: TypeEventService) {
      this.loading_user = true;
      this.loading_enterprise = true;
      this.loading_applyStatus = true;
      this.page_apply_status = 1;
      this.total_apply_status = 0;
      this.max_apply_status = 5;

      this.page_type_event = 1;
      this.total_type_event = 0;
      this.max_type_event = 5;
    }

  ngOnInit() {
    if (localStorage.getItem('premium')){
      this.premium = localStorage.getItem('premium');
    } else {
      this.premium = '0';
    }
    this.enterprise = new Enterprise ();
    this.users = new User();
    this.applyStatuses = new ApplyStatus();

    this.typeEventses = new TypeEvent();

    this.enterpriseService.getEnterprise()
      .subscribe(
        data => {
            this.enterprise = data;
            this.loading_enterprise = false;
          },
        error => this.errorMessage = <any>error
      );

    this.userService.getUser()
      .subscribe(
        data => {
            this.users = data,
            this.max_users = this.users[0].max_users;
            this.total_users = this.users[0].total_users;
            this.loading_user = false;
          },
        error => this.errorMessage = <any>error
      );
      this.searchApplyStatus();
      this.searchTypeEvent();
    }

  onPageChangeAP(page) {
    this.searchApplyStatus(page);
  }

  onPageChangeTypeEvent(page) {
    this.searchTypeEvent(page);
  }

  searchApplyStatus(page?: number, query?: string){
    this.loading_applyStatus = true;
    const status = [];
    this.page_apply_status = page;
    if (page == null) {
      page = 1;
    }
    this.applyStatusService.getApplyStatusList(page, this.max_apply_status, query)
      .subscribe(
        data => {
            this.applyStatuses = data.applystatus,
            this.total_apply_status = data.pagination.total;
            this.loading_applyStatus = false;
          },
        error => this.errorMessage = <any>error
    );
  }

  searchTypeEvent(page?: number, query?: string){
    this.loading_typeEvent = true;
    const status = [];
    this.page_type_event = page;
    if (page == null) {
      page = 1;
    }
    this.typeEventService.getTypeEventList(page, this.max_type_event, query)
      .subscribe(
        data => {
            this.typeEventses = data.eventtype;
            this.total_type_event = data.pagination.total;
            this.loading_typeEvent = false;
          },
        error => this.errorMessage = <any>error
    );
  }

  _keyPressNumber(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  checkMaxUser(){
      if (this.total_users < this.max_users){
        return false;
      }else{
        return true;
      }
  }

  _keyPressLetter(event: any) {
    const pattern = /^[a-zA-Z]+$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onPutEnterprise() {
    this.publicating = true;
    this.enterpriseService.putEnterprise(this.enterprise)
      .subscribe(
        data => {
          this.publicating = false;
        },
        error => {
          this.errorMessage = <any>error
          this.publicating = false;
        }
      );
  }

  openDialog(name,id) {
      let dialogRef = this.dialog.open(UsersComponent);
      dialogRef.afterClosed().subscribe(result => {
        this.selectedOption = result;
        this.userService.getUser()
          .subscribe(
            data => this.users = data,
            error => this.errorMessage = <any>error
          );
      });
      dialogRef.componentInstance.nameComponent=name;
      dialogRef.componentInstance.UserID=id;
      dialogRef.componentInstance.Users=this.users;
  }

  openDialogDelete(id) {
      let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.UserID=id;
      dialogRef.componentInstance.deleteUser=true;
  }

  openDialogApplyStatus(name,id) {
      let dialogRef = this.dialog.open(ApplyStatusComponent);
      dialogRef.afterClosed().subscribe(result => {
        this.searchApplyStatus(this.page_apply_status);
      });
      dialogRef.componentInstance.nameComponent=name;
      dialogRef.componentInstance.ApplyStatusID=id;
      dialogRef.componentInstance.ApplyStatuses=this.applyStatuses;
  }

  openDialogDeleteApplyStatus(id) {
      let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.afterClosed().subscribe(result => {
          this.searchApplyStatus(this.page_apply_status);
      });
      dialogRef.componentInstance.ApplyStatusID=id;
      dialogRef.componentInstance.deleteApplyStatus=true;
      dialogRef.componentInstance.confirm_delete_message="¿Está seguro desea desactivar?";
      dialogRef.componentInstance.confirm_delete_message_tittle="Confirmar Desactivar";
  }

  openDialogTypeEvent(name,id) {
    let dialogRef = this.dialog.open(TypeEventComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.searchTypeEvent(this.page_type_event);
    });
    dialogRef.componentInstance.nameComponent=name;
    dialogRef.componentInstance.TypeEventID=id;
    dialogRef.componentInstance.TypeEventes=this.typeEventses;
  }

  openDialogDeleteTypeEvent(id) {
    let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
        this.searchTypeEvent(this.page_apply_status);
    });
    dialogRef.componentInstance.TypeEventID=id;
    dialogRef.componentInstance.deleteTypeEvent=true;
    dialogRef.componentInstance.confirm_delete_message="¿Está seguro desea desactivar?";
    dialogRef.componentInstance.confirm_delete_message_tittle="Confirmar Desactivar";
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/configuration/configuration.component.ts